export const generateValidUrl = () => {
  return `${window.location.origin}/finishSignIn`;
};
